<template>
    <div class="NodeEditor KbNodeEditor">
        <NodeSaveStatus></NodeSaveStatus>
        <NodeHeaderEditor
            key="NodeHeaderEditor"
            :name.sync="node.name"
            :id="node.id"
            :slug="node.slug"
            :type="node.type"
            ref="NodeHeaderEditor"
            @save="saveNode"
            @delete="deleteNode"
            @close="closePanelRight"
        ></NodeHeaderEditor>
        <div class="scroll-container fci-scrollbar">
            <ScenarioCard name="Prompt" key="Prompt">
                <PromptEditor v-model="node.config.prompt" @save="saveNode"></PromptEditor>
            </ScenarioCard>
            <ScenarioCard name="RePrompt" key="RePrompt">
                <RePromptEditor
                    :items.sync="node.config.rePromptList"
                    @save="shouldSave ? saveNode() : null"
                ></RePromptEditor>
            </ScenarioCard>
            <ScenarioCard
                name="Setting"
                key="Setting"
                v-if="node.config.setting"
                ref="Setting"
                :delete-able="isEdit"
                @delete="deleteSetting('setting')"
            >
                <ApiParameterEditor
                    :items.sync="node.config.setting"
                    @save="shouldSave ? saveNode() : null"
                    :editable="isEdit"
                ></ApiParameterEditor>
            </ScenarioCard>
            <ScenarioSeparator v-if="node.config.cardList.length > 0"></ScenarioSeparator>
            <ScenarioCard
                v-for="(card, cardIndex) in node.config.cardList"
                :key="cardIndex"
                :name.sync="card.name"
                @delete="deleteCard(cardIndex)"
                @moveUp="moveCardUp(cardIndex)"
                @moveDown="moveCardDown(cardIndex)"
                :delete-able="isEdit"
                :move-able="isEdit"
                :name-editable="isEdit"
            >
                <ApiEditor
                    v-if="card.type === CardType.API"
                    :item.sync="card.data"
                    @save="shouldSave ? saveNode() : null"
                    ref="card"
                    :editable="isEdit"
                ></ApiEditor>
                <ApiParameterEditor
                    v-if="card.type === CardType.SET_USER_ATTRIBUTE"
                    :items.sync="card.data"
                    @save="shouldSave ? saveNode() : null"
                    ref="card"
                    :editable="isEdit"
                ></ApiParameterEditor>
                <LuaEditor
                    v-if="card.type === CardType.LUA"
                    :item.sync="card.data"
                    @save="shouldSave ? saveNode() : null"
                    ref="card"
                    :editable="isEdit"
                ></LuaEditor>
            </ScenarioCard>
        </div>
        <NodeFooterEditor
            @menuSelect="onMenuSelect($event)"
        ></NodeFooterEditor>
    </div>
</template>

<script>
import NodeEditor from "@/views/Scenario/NodeEditor/NodeEditor";
import ApiEditor from "@/views/Scenario/NodeEditor/common/ApiEditor";
import ApiParameterEditor from "@/views/Scenario/NodeEditor/common/ApiParameterEditor";
import ScenarioCard from "@/views/Scenario/components/ScenarioCard";
import RePromptEditor from "@/views/Scenario/NodeEditor/kb/RePromptEditor";
import NodeHeaderEditor from "@/views/Scenario/NodeEditor/common/NodeHeaderEditor";
import ScenarioSeparator from "@/views/Scenario/NodeEditor/common/ScenarioSeparator";
import NodeSaveStatus from "@/views/Scenario/NodeEditor/NodeSaveStatus";
import NodeFooterEditor from "@/views/Scenario/NodeEditor/common/NodeFooterEditor";
import PromptEditor from "@/views/Scenario/NodeEditor/kb/PromptEditor";
import LuaEditor from "@/views/Scenario/NodeEditor/common/LuaEditor";

export default {
    name: "KBNodeEditor",
    extends: NodeEditor,
    components: {
        LuaEditor,
        PromptEditor,
        NodeFooterEditor,
        ApiParameterEditor,
        RePromptEditor,
        ApiEditor,
        ScenarioCard,
        NodeHeaderEditor,
        ScenarioSeparator,
        NodeSaveStatus
    },
    methods: {
        validateNodeData() {
            if (!this.node.name) {
                return 'Name not valid'
            }
            let config = this.node.config
            if (config.rePromptList) {
                for (let rePrompt of config.rePromptList) {
                    if (!rePrompt.name) {
                        return 'RePrompt name not valid'
                    }
                    if (!rePrompt.prompt) {
                        return 'RePrompt content not valid'
                    }
                    let validateConditionList = this.validateConditionList(rePrompt.conditionList)
                    if (validateConditionList !== true) {
                        return validateConditionList
                    }
                }
            }
            return true
        }
    }
}
</script>
<style scoped lang="scss">
@import "src/views/Scenario/NodeEditor/NodeEditor";
</style>
